import { useRouter } from "next/router";
import Image from "next/image";
import logo from "../public/images/logo.png";
import { useEffect } from "react";
import xStreamUrlVerify from "../redux/actions/xStream";
import {
  getDataFromStorageHelper,
  storeDataInSession,
  setDataInStorageHelper,
} from "../helper/helper";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { useDispatch, useSelector } from "react-redux";
import EndpointApi from "../redux/actions/endpointApi";
import GetIPAddress from "../redux/actions/ipAddress";
import withInternetConnectivity from "../Components/HOC/withNetworkConnectivity";
import m3uPlaylistURL, { m3uParseData } from "../redux/actions/m3uPlaylist";
import M3U8FileParser from "m3u8-file-parser";
import { showToast } from "../redux/actions/toastActions";
// import { MassiveClient } from "./messive/MassiveClient/MassiveClient";
import MassiveDialog from "../Components/MassiveDialog";
import { useState } from "react";

const Home = () => {
  // useIMAScript();
  const router = useRouter();
  const reader = new M3U8FileParser();
  const dispatch = useDispatch();
  const { setFocus } = useFocusable({});
  const { data: endPoints } = useSelector(
    (State) => State.endpointReducer.endPoints
  );
  console.log(endPoints, 'endpoints');

  const USER_PLAYLIST = getDataFromStorageHelper("USER_PLAYLIST");
  const CLOUD_PLAYLIST = getDataFromStorageHelper("CLOUD_PLAYLIST");
  const LAST_ACTIVE_PLAYLIST = getDataFromStorageHelper("LAST_ACTIVE_PLAYLIST");
  const PRIVACY_CONSENT = getDataFromStorageHelper("isPrivacyconsent")
  const isUserOnPlaylistPage = getDataFromStorageHelper("isUserOnPlaylistPage");
  const PLAYLIST_SELECTED = getDataFromStorageHelper("LAST_ACTIVE_PLAYLIST")
  const PROFILE_DATA = getDataFromStorageHelper("SELECTED_PROFILE")
  const PURPLE_LOGIN_DATA = getDataFromStorageHelper("PURPLE_LOGIN_DATA")
  const MASSIVE_CONSENT = getDataFromStorageHelper("massive_consent");
  const [showMassiveDialog, setShowMassiveDialog] = useState(false);

  const playlistURLValidate = async () => {
    const transformData = {
      URL: LAST_ACTIVE_PLAYLIST.url,
      Username: LAST_ACTIVE_PLAYLIST.username,
      Password: LAST_ACTIVE_PLAYLIST.pwd || LAST_ACTIVE_PLAYLIST.password,
    };
    const response = await xStreamUrlVerify(transformData);
    return response;
  };

  const M3uPlaylistURLValidate = async (url) => {
    // playlist url
    const response = await m3uPlaylistURL(url);
    return response;
  };

  useEffect(() => {
    dispatch(EndpointApi());
    dispatch(GetIPAddress());
  }, []);

  useEffect(() => {
    console.log(endPoints, 'messive');
    if (endPoints != undefined) {
      if (typeof tizen !== "undefined") {
        // const massiveClient = new MassiveClient();
        // massiveClient.init("d50ec98f-d1af-4325-b46f-b4df5c94c4fe", (success) => {
        //   console.log("Massive Service Init Success: ", success);
        //   if (success) {
        //     massiveClient.start();
        //   } else {
        //     console.error("Massive Service Initialization Failed");
        //     dispatch(showToast("Massive Service Initialization Failed", "error"));
        //   }
        // });
      }
      if (PRIVACY_CONSENT !== null) {
        // Check Massive Consent
        // if (MASSIVE_CONSENT === null && !showMassiveDialog) {
        //   setShowMassiveDialog(false);
        //   return; // Stop execution until consent is handled
        // }

        // if (showMassiveDialog) {
        //   return; // Still showing dialog, do not proceed
        // }

        if (PURPLE_LOGIN_DATA != null) {
          if (LAST_ACTIVE_PLAYLIST != null && LAST_ACTIVE_PLAYLIST.username != null) {
            const formbody = new FormData();
            formbody.append("email", JSON.parse(PURPLE_LOGIN_DATA).user.email);
            formbody.append("password", JSON.parse(PURPLE_LOGIN_DATA).password);
            const Url = endPoints.endpoint.login + "/api/login";
            callLoginApi(Url, formbody)
            if (isUserOnPlaylistPage) {
              if (PLAYLIST_SELECTED != null) {
                if (PROFILE_DATA != null) {
                  router.push("/FetchXstreamData");
                } else {
                  router.push(`/ChooseProfile?id=${getDataFromStorageHelper("LAST_ACTIVE_PLAYLIST").id}`)
                }
              } else {
                router.push("/Playlist");
              }
            } else {
              // username key present in Xstrem Url
              if (LAST_ACTIVE_PLAYLIST?.hasOwnProperty("username")) {
                playlistURLValidate().then((resp) => {
                  const { user_info } = resp || [];
                  const currentDate = new Date();
                  const expireDate = new Date(user_info?.exp_date * 1000);
                  const expireDateCheck =
                    expireDate >= currentDate || user_info?.exp_date == null;
                  if (
                    user_info?.status === "Active" &&
                    user_info?.auth !== 0 &&
                    expireDateCheck
                  ) {
                    setDataInStorageHelper("timezone", resp?.server_info?.timezone);
                    if (PROFILE_DATA != null) {
                      router.push("/FetchXstreamData");
                      setFocus("LIVE_TV_FOCUS_KEY");
                    } else {
                      router.push(`/ChooseProfile?id=${getDataFromStorageHelper("LAST_ACTIVE_PLAYLIST").id}`)
                    }
                  }
                });
              } else if (LAST_ACTIVE_PLAYLIST?.hasOwnProperty("epg") && endPoints) {
                m3uPlaylistURL(LAST_ACTIVE_PLAYLIST.url).then((resp) => {
                  if (resp) {
                    reader.read(resp);
                    dispatch(m3uParseData(reader.getResult().segments));
                    router.push({
                      pathname: "/Livetv",
                      query: { login: "M3U" },
                    });
                  } else if (!resp) {
                    router.push("/Playlist");
                  }
                });
              } else if (
                USER_PLAYLIST?.xStream?.length >= 1 ||
                USER_PLAYLIST?.M3U?.length >= 1 ||
                CLOUD_PLAYLIST.length >= 1
              ) {
                router.push("/Playlist");
              } else {
                router.push("/PurpleAddPlayList");
              }
            }
          } else {
            if (getDataFromStorageHelper("isM3U") != undefined) {
              m3uPlaylistURL(LAST_ACTIVE_PLAYLIST.url).then((resp) => {
                if (resp) {
                  reader.read(resp);
                  dispatch(m3uParseData(reader.getResult().segments));
                  router.push("/FetchM3UData")
                } else if (!resp) {
                  router.push("/Playlist");
                }
              });
            } else {
              router.push("/Playlist");
            }
          }
        } else {
          if (USER_PLAYLIST?.xStream?.length >= 1) {
            if (LAST_ACTIVE_PLAYLIST?.hasOwnProperty("username")) {
              playlistURLValidate().then((resp) => {
                const { user_info } = resp || [];
                const currentDate = new Date();
                const expireDate = new Date(user_info?.exp_date * 1000);
                const expireDateCheck =
                  expireDate >= currentDate || user_info?.exp_date == null;
                if (
                  user_info?.status === "Active" &&
                  user_info?.auth !== 0 &&
                  expireDateCheck
                ) {
                  setDataInStorageHelper("timezone", resp?.server_info?.timezone);
                  if (PROFILE_DATA != null) {
                    router.push("/FetchXstreamData");
                    setFocus("LIVE_TV_FOCUS_KEY");
                  } else {
                    if (PURPLE_LOGIN_DATA != null) {
                      router.push(`/ChooseProfile?id=${getDataFromStorageHelper("LAST_ACTIVE_PLAYLIST").id}`)
                    } else {
                      router.push("/FetchXstreamData");

                    }
                  }
                }
              });
            } else if (LAST_ACTIVE_PLAYLIST?.hasOwnProperty("epg") && endPoints) {
              m3uPlaylistURL(LAST_ACTIVE_PLAYLIST.url).then((resp) => {
                if (resp) {
                  reader.read(resp);
                  dispatch(m3uParseData(reader.getResult().segments));
                  router.push({
                    pathname: "/Livetv",
                    query: { login: "M3U" },
                  });
                } else if (!resp) {
                  router.push("/Playlist");
                }
              });
            } else {
              router.push("/Playlist");
            }
          } else {
            router.push("/PurpleLogin")
          }
        }
      } else {
        router.push("/PurpleLogin");
      }
    }
  }, [endPoints]);

  return (
    <div className="Splash-screen-container">
      <Image src={logo} alt="Splash_screen" priority />
      {showMassiveDialog && (
        <MassiveDialog
          onConsent={(isAccepted) => {
            // setShowMassiveDialog(false);
            // Trigger re-evaluation of useEffect or reload? 
            // Since state changes, component re-renders. 
            // We might need to force the effect to run again or manually call logic.
            // Simplest is to let the state change trigger a re-render, 
            // but useEffect dependency is [endPoints].
            // We need to trigger the navigation logic again.
            // We can add showMassiveDialog to useEffect dependency 
            // OR just call a function to proceed.
            window.location.reload();
          }}
        />
      )}
    </div>
  );
};

export default Home;

const callLoginApi = (Url, formDatas) => {
  console.log(formDatas);

  fetch(Url, {
    method: "POST",
    body: formDatas
  })
    .then((response) => response.json())
    .then((result) => {
      console.log(result);
      if (result.data !== undefined) {
        result.data["password"] = formDatas.password
        setDataInStorageHelper("PURPLE_LOGIN_DATA", JSON.stringify(result.data));
      } else {
        if (activeTab === "login") {
          dispatch(showToast(result.message, "error"));
        } else {
          dispatch(showToast(result.errors?.email?.[0] || "Registration failed", "error"));
        }
      }
    })
    .catch((error) => console.error(error));
};
